import React from 'react';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const StressManagement = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter vidSrc={1194425995} />
    </div>
  );
};

export default StressManagement;
